import { createComponent, EnvironmentInjector, Injectable } from '@angular/core';
import { Icon, ZenithAppearance } from '../zenith-enums';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageUtil } from '../../common/error-response/message.util';
import { ZenithToastComponent } from './zenith-toast.component';

@Injectable({
  providedIn: 'root'
})
export class ZenithToastService {
  constructor(private readonly injector: EnvironmentInjector) {}

  // TODO ZNT-1418 : informed if we can keep a zenith-toast open, could be useful for fatal errors where the user needs
  // to take an action (e.g refresh or navigate back)
  showToast(
    content: string | Error | HttpErrorResponse,
    appearance: ZenithAppearance = ZenithAppearance.NEUTRAL,
    icon?: Icon
  ) {
    const toast = createComponent(ZenithToastComponent, { environmentInjector: this.injector });
    toast.setInput('content', MessageUtil.toContent(content).message);
    toast.setInput('appearance', appearance);
    toast.setInput('icon', icon);
    toast.changeDetectorRef.detectChanges();
    document.body.appendChild(toast.location.nativeElement);
  }

}
